<template>
  <div>
    <div v-if="!url" data-v-377afdca="" class="loading-mask-container">
      <div data-v-377afdca="" class="loading-icon-wrapper" ><img data-v-377afdca="" src="/static/image/rotate.963673.png" alt="" class="loading-rotate-img" /></div>
    </div>
    <div v-else style="height: calc(100vh - 100px); overflow-y: scroll; -webkit-overflow-scrolling: touch;">
      <iframe style="height: 100%; width: 100%"  ref="iframe" scrolling="auto" frameborder="0"  id="iframe"></iframe>
      <!--  -->
    </div>
  </div>
</template>
<script>

export default {
  name: 'gamePage',
  data() {
    return {
      url: null,
    };
  },
  created() {
    let that = this;
    var query = that.$route.query;
    if (query.dailiD) {
      if (query.dailiD == 1) {
        that.$apiFun.get('/api/getAgentLoginUrl', {}).then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
            
          }
        });
        return;
      } else {
        that.$apiFun.post('/api/getservicerurl', {}).then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.url = res.data.url;
            

          }
        });
      }
    }
    if (query.name) {
      that.goGamePage(query.name, query.type, query.code,query.supplier);
    }
  },
  methods: {
    goGamePage(name, type, code,supplier) {
      let that = this;
       that.$parent.showLoading();
      that.$apiFun
        .post('/api/getGameUrl', { plat_name: name, game_type: type || 0, game_code: code, is_mobile_url: 1,supplier:supplier })
        .then(res => {
          if (res.code != 200) {
            that.$parent.hideLoading();
            that.$parent.showTost(0, res.message);
          }
          if (res.code == 200) {
           that.$parent.hideLoading();
            that.url = res.data.url;
            // this.handleOpen(res.data.url)
            // this.$router.back()
           
          }
        })
        .catch(res => { that.$parent.hideLoading(); });
    },

    handleOpen(url) {
      const _u = navigator.userAgent
      const ios = _u.indexOf('iPhone') > -1
      const iPad = _u.indexOf('iPad') > -1
      if (ios || iPad) {
        window.location.replace(url)
      } else {
        if (url.includes('https://')) {
          //window.open(url)
           window.open(url, '_blank');
        } else {
          window.location.href = url
        }
      }


      /*
      const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
      
      if (isIOS) {
        const link = document.createElement('a');
        link.href = url;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        window.open(url, '_blank');
      }
        */
    }

  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
    that.$refs.iframe.contentWindow.location.replace(that.url)
  },

};
</script>

<style lang="scss" scoped>
@import '../../../static/css/chunk-099d4415.690b75b1.css';
</style>



// WEBPACK FOOTER //
// src/components/main/gamePage.vue